import { render, staticRenderFns } from "./MemberTable.vue?vue&type=template&id=31b12132"
import script from "./MemberTable.vue?vue&type=script&lang=js"
export * from "./MemberTable.vue?vue&type=script&lang=js"
import style0 from "./MemberTable.vue?vue&type=style&index=0&id=31b12132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports